import React from 'react';
import { useUserData } from '@/components/pages/SettingsPage/MainContent/shared/useUserData';
import { Skeleton } from '@/components/ui/skeleton';
import { UserDetailsForm } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';

export const CreateUser = () => {
  const { userData, isLoadingUserData } = useUserData();

  if (isLoadingUserData) {
    return <Skeleton className="h-full" />;
  }

  return <UserDetailsForm userData={null} isLoadingUserData={isLoadingUserData} />;
};
